// definir un objeto mixin
var MpCookieConsent = {
    data: function() {
        return {
            allowedTypes: null,
        };
    },
    computed: {

    },
    methods: {

        updateStatus: function() {
            this.cookiesAccepted = CookieManager.cookiesAccepted();
        },

        updateTypeStatus: function() {
            this.allowedTypes = {
                own: true,
                analytics: CookieManager.isTypeAllowed(CookieManager.TYPE_ANALYTICS),
                marketing: CookieManager.isTypeAllowed(CookieManager.TYPE_MARKETING),
            };
        },

        activateIframes: function(allowed) {
            var iframeList = document.querySelectorAll('.js-cookies-iframe');
            var i, j,
                allowedFrame,
                tmpClass,
                iframeClasses;

            for (i=0; i<iframeList.length; i++) {
                iframeList[i].setAttribute('src', '');

                if (!allowed || allowed === '') {
                    continue;
                }

                allowedFrame = true;
                iframeClasses = iframeList[i].classList;

                j=0;
                while (allowedFrame && j<iframeClasses.length) {
                    tmpClass = iframeClasses.item(j);

                    if (tmpClass !== 'js-cookies-iframe') {
                        allowedFrame = (allowed.lastIndexOf(tmpClass)>=0);
                    }

                    j++;
                }

                if (allowedFrame) {
                    iframeList[i].setAttribute('src', iframeList[i].getAttribute('data-src'));
                }
            }
        },

        updateIframes: function() {
            var allowed = '';

            allowed += (this.allowedTypes[CookieManager.TYPE_ANALYTICS]) ? '*'+ CookieManager.TYPE_ANALYTICS : '';
            allowed += (this.allowedTypes[CookieManager.TYPE_MARKETING]) ? '*'+ CookieManager.TYPE_MARKETING : '';

            this.activateIframes(allowed);
        },
    },

    created: function() {

    },

    destroyed: function() {

    }
};
